namespace TabAurous.Purchase {
    export interface MaterialInItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        HasBom: Serenity.BooleanEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        StampId: Serenity.LookupEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        CalcUnitId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        UnitLabour: Serenity.DecimalEditor;
        FancyCharges: AmountEditor;
        OtherCharges: AmountEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.StringEditor;
        BOMDetails: MaterialInBOMEditor;
    }

    export class MaterialInItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.MaterialInItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MaterialInItemsForm.init)  {
                MaterialInItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.LookupEditor;
                var w4 = CommonCategoryLookup;
                var w5 = StoneSieveLookup;
                var w6 = WeightEditor;
                var w7 = s.DecimalEditor;
                var w8 = AmountEditor;
                var w9 = s.DateEditor;
                var w10 = MaterialInBOMEditor;

                Q.initFormType(MaterialInItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'HasBom', w2,
                    'AttributeId', w0,
                    'ProductTypeId', w3,
                    'CategoryId', w4,
                    'SubCategoryId', w3,
                    'BrandId', w3,
                    'SuperTypeId', w3,
                    'CollectionId', w3,
                    'StampId', w3,
                    'MetalId', w3,
                    'Attribute', w0,
                    'CalcUnitId', w3,
                    'KaratId', w3,
                    'MetalColorId', w3,
                    'ShapeId', w3,
                    'StoneColorId', w3,
                    'QualityId', w3,
                    'StoneSizeId', w3,
                    'SieveId', w5,
                    'GroupSieveId', w5,
                    'StoneCutId', w3,
                    'StonePolishId', w3,
                    'StoneSymmetryId', w3,
                    'StoneFluorescenceId', w3,
                    'StoneCuletId', w3,
                    'StoneGirdleId', w3,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'Lab', w3,
                    'Pieces', w1,
                    'Weight', w6,
                    'UnitRate', w7,
                    'StoneRate', w8,
                    'OtherRate', w8,
                    'UnitLabour', w7,
                    'FancyCharges', w8,
                    'OtherCharges', w8,
                    'NetAmount', w7,
                    'GrossAmount', w7,
                    'CCNetAmount', w7,
                    'CCGrossAmount', w7,
                    'Line_No', w0,
                    'HSN', w3,
                    'NetWeight', w6,
                    'DiamondPieces', w1,
                    'DiamondWeight', w6,
                    'StonePieces', w1,
                    'StoneWeight', w6,
                    'OtherPieces', w1,
                    'OtherWeight', w6,
                    'Purity', w7,
                    'PureWeight', w6,
                    'MetalAmount', w7,
                    'DiamondAmount', w7,
                    'StoneAmount', w7,
                    'OtherAmount', w7,
                    'CalcOnId', w3,
                    'UnitCost', w7,
                    'Discount', w7,
                    'WstPer', w7,
                    'WstWt', w6,
                    'Remarks', w0,
                    'IsDisabled', w2,
                    'ServerDate', w9,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w9,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'ImageName', w0,
                    'BOMDetails', w10
                ]);
            }
        }
    }
}
